import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import useIsGlobetrotter from '../../hooks/useIsGlobetrotter.js';
import { Icon as Icon$2 } from './Icon.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["path", "size", "sizeMobile", "titleText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Icon = function Icon(_ref) {
  var path = _ref.path,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    _ref$sizeMobile = _ref.sizeMobile,
    sizeMobile = _ref$sizeMobile === void 0 ? null : _ref$sizeMobile,
    _ref$titleText = _ref.titleText,
    titleText = _ref$titleText === void 0 ? '' : _ref$titleText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isGlobe = useIsGlobetrotter();
  if (!path) {
    return false;
  }
  var themedIcon = isGlobe ? path.globetrotter : path["default"];
  if (!themedIcon) {
    return false;
  }
  var isGlobeIcon = isGlobe && path.globetrotter;
  var strokeBasedIcon = path.v2 || isGlobeIcon;
  var viewBox = path.v2 ? '0 0 24 24' : '0 0 32 32';
  var roundEdges = !isGlobe && path.v2 ? {
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  } : {};
  return /*#__PURE__*/jsxs(Icon$2, _objectSpread(_objectSpread(_objectSpread({
    viewBox: viewBox,
    xmlns: "https://www.w3.org/2000/svg"
    // @ts-ignore
    ,
    $size: size,
    $sizeMobile: sizeMobile,
    $strokeBasedIcon: strokeBasedIcon,
    fill: strokeBasedIcon ? 'none' : 'currentColor',
    stroke: strokeBasedIcon ? 'currentColor' : 'none',
    "aria-hidden": "true"
  }, roundEdges), rest), {}, {
    children: [titleText && /*#__PURE__*/jsx("title", {
      children: titleText
    }), /*#__PURE__*/jsx("path", {
      d: themedIcon
    })]
  }));
};
var Icon$1 = Icon;

export { Icon$1 as default };
//# sourceMappingURL=Icon.js.map
